import * as API from '@/API'

const createState = () => ({
  isLoading: false,
  devices: null,
  patchPanels: null,
})

const deviceSearchableFields = ['name', 'model', 'location_description', 'location_facility', 'make']

const panelSearchableFields = ['name', 'location_facility', 'location_description', 'type', 'notes']

const addSearchableTextText = (map, searchableFields) => {
  map.searchable_text = searchableFields.map(field => {
    return map[field] !== undefined && map[field] !== null ? map[field] : ''
  }).join(' ')

  return map
}

const parseResults = (results, searchableFields) => {
  return results.filter(item => item !== null).sort((a, b) => a.name.localeCompare(b.name)).map(item => addSearchableTextText(item, searchableFields))
}

const actions = {
  async getDevices({ commit, state }) {
    if (state.devices) return
    commit('setLoadingStatus', true)
    try {
      const results = await API.getPatchingDevices()
      commit('setNodeValue', { key: 'devices', value: parseResults(results, deviceSearchableFields) })
    } finally {
      commit('setLoadingStatus', false)
    }
  },
  async getPatchPanels({ commit, state }) {
    if (state.patchPanels) return
    commit('setLoadingStatus', true)
    try {
      const results = await API.getPatchingPatchPanels()
      commit('setNodeValue', { key: 'patchPanels', value: parseResults(results, panelSearchableFields) })
    } finally {
      commit('setLoadingStatus', false)
    }
  },
}

const mutations = {
  setLoadingStatus: (state, value) => {
    state.isLoading = value
  },
  setNodeValue: (state, nodeObject) => {
    state[nodeObject.key] = nodeObject.value
  },
}

export default {
  namespaced: true,
  actions,
  mutations,
  state: createState(),
}
